export const ALLOWED_SIGN_IN_DOMAIN = 'skin-seoul.com';

// TEMPORARY: outside Google accounts admitted until 2027-11-03 (end of day KST). The entries lapse on
// their own after this instant, at sign-in and on stored-session restore. Remove them once expired.
const TEMPORARY_SIGN_IN_EXPIRES_AT = Date.parse('2027-11-03T23:59:59+09:00');
const TEMPORARY_SIGN_IN_EMAILS: ReadonlySet<string> = new Set(['eompurple@gmail.com', 'lys0333@gmail.com']);

/** Whether a Google account may sign in to the admin at `now`. */
export const isAllowedSignInEmail = (email: string, now: Date = new Date()): boolean => {
  if (email.endsWith(`@${ALLOWED_SIGN_IN_DOMAIN}`)) {
    return true;
  }
  return TEMPORARY_SIGN_IN_EMAILS.has(email.toLowerCase()) && now.getTime() <= TEMPORARY_SIGN_IN_EXPIRES_AT;
};
